import React from 'react';
import { 
    Card,
    Image,
    Text,
    Group,
    Badge,
    createStyles,
    Center,
    Button,
    ActionIcon
} from '@mantine/core';
import {
    IconGavel,
    IconHourglass,
    IconHeartPlus,
    IconHeart,
    IconEye,
    IconBell
} from '@tabler/icons';
const useStyles = createStyles((theme) => ({
    cardContain: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,    
        //width: '80%'
        width: 'inherit'
        
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /*borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,*/
    },
    
    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        letterSpacing: -0.25,
        textTransform: 'uppercase',
    },

    section: {
        padding: theme.spacing.md,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    subSection: {
        borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
        textAlign: 'center',
        paddingBottom: '1%'
    },

    icon: {
        marginRight: 5,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
}));

//<Image src="https://i.imgur.com/ZL52Q2D.png" alt="Tesla Model S" />
export function CarCardDetsBids() {
  const { classes } = useStyles();

    return (
        <Card withBorder radius="md" className={classes.cardContain}>
            <Card.Section className={classes.section} mt="md">
                <Text size="lg" weight={700}>
                A_userNam3
                </Text>
                <br/>
                <Text size="md" color="dimmed" className={classes.label}>
                12/27/22 at 2:55 PM
                </Text>
            </Card.Section>
            <Card.Section className={classes.section,classes.subSection}>
                <Text size="lg" weight={700} td="underline" sx={{ lineHeight: 1 }}>
                    $95,000
                </Text>
            </Card.Section>
        </Card>
    );
}
